import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import styled from 'styled-components';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Badge,
  Input,
} from 'reactstrap';
import 'react-calendar/dist/Calendar.css';
import { Calendar } from 'react-calendar';
import {
  FaArrowCircleRight,
  FaArrowRight,
  FaEdit,
  FaEye,
  FaPlus,
  FaSearch,
  FaTrash,
  FaQrcode,
} from 'react-icons/fa';
import { CalendarLocal } from '../components/CalendarLocal';
import { ModalAddEvent } from '../components/modalAddEvent/index';
import { useEvent } from './../../hooks/useEvent';
import Loading from 'react-loading';
import SearchBar from '../components/searchBar';
import { apiAp } from './../../services/apiAmapá';
import { api } from './../../services/api';
import axios from 'axios';
import { TablePadrão } from './../components/table/index';
import { ModalEditUser } from '../components/modalEditUser';
import { toast } from 'react-toastify';
import { ModalEditDependent } from '../components/modalEditDependent';

import { ModalQRCodeViewer } from '../components/modalQrCodeViewer';

interface DependentType {
  id: number;
  nome: string;
  apelido: string;
  idade: string;
  relacao_responsavel: string;
  contato_emergencia: string;
  contato_emergencia_opcional: string;
  possui_deficiencia_invisivel: boolean;
  tipo_dependente: string;
  especie: string;
  veterinario: string;
  veterinario_contato: string;
  condicoes_medicas: string[];
  alergias: string[];
  medicacoes: string[];
  tipo_deficiencia: string[];
  equipamentos_assistencia: string[];
  user: {
    name: string;
    email: string;
    cpf: string;
    phone: string;
  };
}

export function Dependents(): React.JSX.Element {
  const [inputAdded, setInputAdded] = useState('');
  const [inputNotAdded, setInputNotAdded] = useState('');
  const [companyDefault, setCompanyDefault] = useState<DependentType[]>([]);
  const [company, setCompany] = useState<DependentType[]>([]);
  const [selected, setSelected] = useState<DependentType>();
  const [currentStatus, setCurrentStatus] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingLocal, setLoadingLocal] = useState(true);

  const [isOpenQRModal, setIsOpenQRModal] = useState(false);
  const [selectedDependentId, setSelectedDependentId] = useState<number | null>(null);

  function handleOpenQRModal(id: number): void {
    setSelectedDependentId(id);
    setIsOpenQRModal(true);
  }

  function handleCloseQRModal(): void {
    setIsOpenQRModal(false);
    setSelectedDependentId(null);
  }

  const [loadingSearch, setLoadingSearch] = useState(false);
  const [septemberDays, setSeptemberDays] = useState<Date[]>([]);
  const [isOpenModalUser, setIsOpenModalUser] = useState(false);
  const [inputNameOrCNPJ, setInputNameOrCNPJ] = useState(null);

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  function handleIsOpenModalUser(): void {
    setIsOpenModalUser(!isOpenModalUser);
  }

  function localUserHandleOpenModal(item: DependentType): void {
    setSelected(item);
    handleIsOpenModalUser();
  }

  async function findCompaniesPerPage(targetPage: number): Promise<void> {
    setLoading(true);
    setInputNameOrCNPJ('');
    try {
      let response;

      if (currentStatus) {
        response = await api.get('dependent', {
          params: {
            page: targetPage,
            perPage,
            paginated: true,
          },
        });
      } else {
        response = await api.get('dependent', {
          params: {
            page: targetPage,
            perPage,
            paginated: true,
          },
        });
      }
      setCompany(response.data.dependents);

      setCompanyDefault(response.data.dependents);

      setPage(response.data.page);
      setTotalPages(response.data.totalPages);

      setLoading(false);
      setLoadingLocal(false);
    } catch (err) {
      const message = 'Ocorreu um erro ao buscar os dados da empresa';
      setLoading(false);
      toast(message, {
        type: 'error',
      });
    }
  }

  useEffect(() => {
    findCompaniesPerPage(1)
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  }, [perPage]);

  async function filter(): Promise<void> {
    setLoadingLocal(true);

    if (inputNameOrCNPJ?.length === 0) {
      await findCompaniesPerPage(1);
    } else {
      try {
        const response = await api.get('dependent', {
          params: {
            search: String(inputNameOrCNPJ),
            page: 1,
            perPage,
            paginated: true,
          },
        });
        setCompany(response.data.dependents);
        setPage(response.data.page);
        setTotalPages(response.data.totalPages);
        setLoadingLocal(false);
      } catch (error) {
        console.log(error);
        setLoadingLocal(false);
      }
    }
  }
  useEffect(() => {
    if (inputNameOrCNPJ !== null) {
      const handler = setTimeout(() => {
        filter().catch((err) => {
          console.log(err);
        });
      }, 500); // debounce de 500ms

      return () => {
        clearTimeout(handler); // limpa timeout anterior se inputNameOrCNPJ mudar rápido
      };
    }
  }, [inputNameOrCNPJ]);

  // const thead = ['Nome', 'Endereço', 'Telefone', 'Status', 'Ações'];
  // const headWidth = ['25%', '25%', '20%', '20%', '10%'];

  const thead = ['Dependente', 'Responsável', 'Parentesco', 'Tipo de dependente', 'Ações'];
  const headWidth = ['30%', '20%', '20%', '20%', '10%'];

  useEffect(() => {
    if (currentStatus !== null) {
      findCompaniesPerPage(1)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
  }, [currentStatus]);

  return (
    <div style={{ width: '100%', backgroundColor: '#FFF', minHeight: '90vh' }}>
      {loading ? (
        <div
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 25 }}
        >
          <Loading width={30} color={'#005675'} type={'spin'} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 50,
            marginTop: 40,
            marginRight: 50,
          }}
        >
          <div className="col-sm-4" style={{ display: 'flex', marginBottom: 15, marginTop: 15 }}>
            <h4>Dependentes</h4>
          </div>

          <div style={{ border: '1px solid rgba(0, 0, 0, 0.05)' }}>
            <div className="d-flex justify-content-between flex-column flex-md-row p-3 gap-4">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 50,
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 15,
                    marginTop: 0,
                  }}
                >
                  <span>Mostrar</span>
                  <Input
                    type="select"
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                    }}
                    style={{ width: 80, marginRight: 8, marginLeft: 8 }}
                    value={perPage}
                  >
                    <option key={'10'} value={'10'}>
                      10
                    </option>
                    <option key={'20'} value={'20'}>
                      20
                    </option>
                    <option key={'30'} value={'30'}>
                      30
                    </option>
                  </Input>
                  <span>registros</span>
                </div>
                <div
                  className="col-sm-4"
                  style={{
                    display: 'flex',
                    marginBottom: 15,
                    flexDirection: 'column',
                  }}
                >
                  <Input
                    value={inputNameOrCNPJ}
                    onChange={(e) => {
                      // eslint-disable-next-line @typescript-eslint/no-floating-promises
                      setInputNameOrCNPJ(e.target.value);
                    }}
                    placeholder={
                      'Pesquise por: nome do dependente, responsável, parentesco ou tipo de dependente.'
                    }
                    style={{ width: 625 }}
                  />

                  {/* <p style={{ fontSize: 14, marginTop: 5 }}>{'(Insira pelo menos 4 caracteres)*'}</p> */}
                </div>
              </div>{' '}
            </div>
            <br />
            {loadingLocal ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 25,
                }}
              >
                <Loading width={30} color={'#005675'} type={'spin'} />
              </div>
            ) : company?.length === 0 && !loadingLocal ? (
              <div className="c-text-danger d-flex justify-content-center mt-20">
                Nenhum dependente encontrado.
              </div>
            ) : (
              <TablePadrão
                page={page}
                totalPage={totalPages}
                thead={thead}
                headWidth={headWidth}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                handleChangePage={findCompaniesPerPage}
              >
                {company?.map((item, i) => {
                  console.log(totalPages);
                  return (
                    <tr
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: i % 2 === 0 ? '#F5F9FF' : '#FFF',
                        padding: 10,
                      }}
                      key={item?.id}
                    >
                      <td
                        style={{
                          width: '30%',
                          justifyContent: 'start',
                          textAlign: 'start',
                          marginLeft: 10,
                        }}
                      >
                        {item?.nome}
                      </td>
                      <td
                        style={{
                          width: '20%',
                          justifyContent: 'start',
                          textAlign: 'center',
                        }}
                      >
                        {item?.user?.name}
                      </td>
                      <td style={{ width: '20%', textAlign: 'center' }}>
                        {item?.relacao_responsavel}
                      </td>
                      <td style={{ width: '20%', textAlign: 'center' }}>{item?.tipo_dependente}</td>
                      <td
                        style={{
                          width: '10%',
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          gap: 12,
                        }}
                      >
                        <FaEye
                          color="#0D6EFD"
                          style={{ cursor: 'pointer' }}
                          onClick={() => localUserHandleOpenModal(item)}
                          title="Ver detalhes"
                        />
                        <FaQrcode
                          color="#0D6EFD"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleOpenQRModal(item.id)}
                          title="Ver QR Code"
                        />
                      </td>
                    </tr>
                  );
                })}
              </TablePadrão>
            )}
          </div>
        </div>
      )}
      {selected && (
        <ModalEditDependent
          company={selected}
          handleIsOpen={handleIsOpenModalUser}
          isOpen={isOpenModalUser}
        />
      )}
      {selectedDependentId && (
        <ModalQRCodeViewer
          isOpen={isOpenQRModal}
          onClose={handleCloseQRModal}
          dependentId={selectedDependentId}
        />
      )}
    </div>
  );
}
